import docReady from '../../../../assets/js/docReady';

let trackingRunning = false;

function trackingReplacer(reference) {
    const comparer = document.getElementById('vergelijkdirect-comparison-module');

    if (comparer !== null && comparer.shadowRoot !== null) {
        const linkElements = comparer.shadowRoot.querySelectorAll('a');

        for (let i = 0; i < linkElements.length; i += 1) {
            const href = linkElements[i].getAttribute('href');

            if (href != null && href.includes('KEUZE')) {
                linkElements[i].setAttribute('href', href.replace('KEUZE', reference));
                // eslint-disable-next-line no-console
                console.log('replaced link', href, href.replace('KEUZE', reference));
            }
        }

        const imageElements = comparer.shadowRoot.querySelectorAll('img');

        for (let i = 0; i < imageElements.length; i += 1) {
            const src = imageElements[i].getAttribute('src');

            if (src != null && src.includes('KEUZE')) {
                imageElements[i].setAttribute('src', src.replace('KEUZE', reference));
                // eslint-disable-next-line no-console
                console.log('replaced img src', src, src.replace('KEUZE', reference));
            }
        }
    }

    trackingRunning = true;

    setTimeout(() => {
        trackingReplacer(reference);
    }, 500);
}

function setupTracking() {
    if (trackingRunning) {
        return;
    }

    if (typeof window.global_tracking !== 'undefined') {
        // eslint-disable-next-line no-console
        console.log('Setup VD tracking');
        trackingReplacer(window.global_tracking);

        return;
    }

    setTimeout(() => {
        setupTracking();
    }, 200);
}

docReady(() => {
    setupTracking();
});
